<ng-container *ngIf="hasContent; then subheaderContentTemplate else subheaderNavigationTemplate"></ng-container>
<ng-template #subheaderNavigationTemplate>
  <div class="subheader-navigation-container">
    <a a11y_Button class="subheader-navigation-link"
      [class.subheader-navigation-link__enabled]="enableNavigateBackButton" matRipple matRippleCentered="true"
      (click)="navigateBack()">
      <div class="inline-icon ya-subheader-navigation-back" inlineSVG="shop-icons.svg#ya-keyboard_backspace"></div>
    </a>
  </div>
</ng-template>
<ng-template #subheaderContentTemplate>
  <div class="subheader-content-container">
    <div>
      <a a11y_Button class="subheader-navigation-link"
        [class.subheader-navigation-link__enabled]="enableNavigateBackButton" matRipple matRippleCentered="true"
        (click)="navigateBack()">
        <div class="inline-icon ya-subheader-navigation-back" inlineSVG="shop-icons.svg#ya-keyboard_backspace"></div>
      </a>
    </div>
    <div class="subheader-content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>